export default "__VITE_ASSET__CMvdDw4H__"